import {
  Progress,
} from '@mantine/core';
import React from 'react';

import progressStyles from '#components/ui/progress/PendingProgress.module.scss';

interface PendingProgressProps {
  value?: number;
}

const defaultProps: PendingProgressProps = {
  value: 100,
};

export function PendingProgress(props: PendingProgressProps): React.ReactNode {
  const mergedProps: PendingProgressProps = {
    ...defaultProps,
    ...props,
  };
  return (
    <div
      className={ progressStyles.root }
    >
      <Progress
        size="xl"
        color="accent.8"
        // value={ mergedProps.value as number }
        value={ 100 }
        striped
        animated
      />
    </div>
  );
}

export default PendingProgress;
